import { render, staticRenderFns } from "./ProtocoloObservacao.vue?vue&type=template&id=066db1e4&scoped=true&"
import script from "./ProtocoloObservacao.vue?vue&type=script&lang=js&"
export * from "./ProtocoloObservacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066db1e4",
  null
  
)

export default component.exports